import { z } from "zod";
import { DbBool, IsoDateTime } from "./common.ts";

/** Local CoyKoi user id (`usr_…`). Distinct from Clerk's `user_…` external id. */
export const UserIdSchema = z
  .string()
  .regex(/^usr_[A-Za-z0-9_-]{8,32}$/, "Expected a CoyKoi user id");

export const UserSchema = z.object({
  id: UserIdSchema,
  clerk_user_id: z.string().min(1),
  display_name: z.string().min(1).max(200),
  is_admin: DbBool,
  created_at: IsoDateTime,
});

export type User = z.infer<typeof UserSchema>;

/** Wire shape for `GET /api/me` — what the client needs after sign-in. */
export const MeResponseSchema = z.object({
  user: UserSchema,
});

export type MeResponse = z.infer<typeof MeResponseSchema>;
